import { ApolloError } from '@apollo/client'

import { GetCustomerSettingsPractitionerDocument } from '../../../graphql/camel'
import useCamelQuery from '../../../hooks/useCamelQuery'
import useUserCategory from '../../../hooks/useUserCategory'
import type { PractitionerSettings } from '../types'
import { practitionerSettingsFromResponse } from '../utils'

export type UsePractitionerSettingsOptions =
  | {
      skip?: boolean
    }
  | undefined

export type UsePractitionerSettings = [
  settings: PractitionerSettings | undefined,
  metadata: { loading: boolean; error: ApolloError | Error | undefined; called: boolean },
]

export const usePractitionerSettings = ({
  skip,
}: UsePractitionerSettingsOptions = {}): UsePractitionerSettings => {
  const { userCategory } = useUserCategory()
  const { data, loading, error, called } = useCamelQuery(GetCustomerSettingsPractitionerDocument, {
    skip: userCategory !== 'practitioner' || skip,
  })

  const loadedSettings = data ? practitionerSettingsFromResponse(data) : undefined
  return [loadedSettings, { loading, error, called }]
}
